/** блок адаптации **/
import './common/adapterFromOldStyle'
/** блок адаптации **/

import { eventEmitter, lang, currentCityId, currentCityName, dynRem, sessid, esputnikTracker, analytics } from './common/baseData'

// Styles
import './catalog/offers-list/style.css';
import './catalog/offers-list/colors.css';
import './catalog/share-social/style.css';
import './faq/callback-form/style.css';
import './common/styles/product-payment.css';
import './components/productPage/productDescription/style.css'
import './components/productPage/productReviews/ProductReviews.css'
import './components/productPage/productCharacteristics/ProductCharacteristics.css'
import './components/usedProductContent/usedProductContent.css'
import './order/apple-pay/style.css'
import './paylate/style.css';

// Javascript
import {Product} from './catalog/product';
import React, {lazy, Suspense} from 'react'
import ReactDOM from "react-dom";
import SetList from "./components/setList/SetList";
import Cookies from 'js-cookie'
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Reviews from './components/reviews/Reviews'
import ProductGuaranteeList from './components/productGuaranteeList/ProductGuaranteeList'
import Reccoms from './components/productPage/reccoms/Reccoms'
import ViewedProductsSlider from './components/viewedProductsSlider/ViewedProductsSlider'
import {ApplePayHelper} from "./order/apple-pay";
import {createRoot} from 'react-dom/client';

const FaqList = lazy(() => import('./components/productPage/faqList/FaqList'))
const ProductModal = lazy(() => import('./components/productPage/productModal/ProductModal'))
const ProductSticky = lazy(() => import('./components/productPage/productSticky/ProductSticky'))
const CrossProductList = lazy(() => import('./components/productPage/crossProductList/CrossProductList'))
const CheaperThanNew = lazy(() => import('./components/productPage/cheaperThanNew/CheaperThanNew'))
const CreditServicesList = lazy(() => import('./components/productPage/creditServicesList/CreditServicesList'))
const UsedProductContentSection = lazy(() => import('./components/usedProductContent/usedProductContent'))
const TimeRemaining = lazy(() => import('./components/productPage/specialDealTimer/TimeRemaining'))
const TradeIn = lazy(() => import('./components/productPage/tradeIn/TradeIn'))
const ProductDelivery = lazy(() => import('./components/productPage/productDelivery/ProductDelivery'))
const ProductNewAlternativeInfo = lazy(() => import('./components/productPage/productNewAlternativeInfo/ProductNewAlternativeInfo'))
const ProductAlternativeInfo = lazy(() => import('./components/productPage/productAlternativeInfo/ProductAlternativeInfo'))
const ProductSpecialDeal = lazy(() => import('./components/productSpecialDeal/ProductSpecialDeal'))
const RecommendationProductList = lazy(() => import('./components/productPage/recommendationProductList/RecommendationProductList.js'))
const Viewed = lazy(() => import('./components/categoryPage/viewed/Viewed'))
const ProductRelatedLinks = lazy(() => import('./components/productPage/relatedLinks/ProductRelatedLinks'))

let currentProductPrice = null

eventEmitter.on('productPriceChanged', data => {
    const price = Number(data && data.price)

    if (!Number.isFinite(price)) return

    const formattedPrice = `${new Intl.NumberFormat(lang === 'ua' ? 'uk-UA' : 'ru-RU').format(price)} ₴`
    currentProductPrice = formattedPrice

    document.querySelectorAll('[data-container="product-price"]').forEach(node => {
        node.textContent = formattedPrice
    })
})

// Авторизуйся, чтобы получить свою цену
let authPriceBanner = document.querySelector('[data-container="auth-price-banner"]')
if (authPriceBanner instanceof HTMLElement) {
    authPriceBanner.addEventListener('click', e => {
        if (e.target.closest('[data-use="auth-price-banner-login"]')) {
            e.preventDefault()
            eventEmitter.emit('showAuth')
        }

        if (e.target.closest('[data-use="auth-price-banner-close"]')) {
            e.preventDefault()
            const expirationDate = new Date(Date.now() + 60 * 60 * 24 * 1000).toUTCString()
            document.cookie = `auth-price-banner-hidden=Y; expires=${expirationDate}; path=/;`
            authPriceBanner.remove()
        }
    })
}

// Swiper slider / просмотренные товары
new ViewedProductsSlider().init()

// скролл по якорю на карточке товара
let allAnchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');
let productDescriptionHolder = document.querySelector('.section-about-text-block')

function loadAllImages(imagesList) {
    // Принудительная загрузка изображений
    imagesList.forEach(img => img.setAttribute('loading', 'eager'));
}

function scrollToAnchor(item) {
    let anchorId = item.getAttribute('href').substring(1);
    let targetElement = document.getElementById(anchorId);
    if (targetElement) {
        let elementOffset = targetElement.getBoundingClientRect().top;
        window.scrollTo({
            top: window.pageYOffset + elementOffset - 80,
            behavior: 'smooth'
        });
    }
}

document.querySelectorAll('.js-product-video-nav').forEach(item => {
    item.addEventListener('click', (event) => {
        event.preventDefault();

        let videoLabel = document.querySelector('.product-video-label.js-product-modal');

        if (videoLabel instanceof HTMLElement) {
            videoLabel.click();
        }
    });
});

allAnchorLinks.forEach(item => {
    item.addEventListener('click', (e) => {
        e.preventDefault();
        let productDescriptionImages = productDescriptionHolder.querySelectorAll('img[loading="lazy"]');

        if (productDescriptionImages.length > 0) {
            loadAllImages(productDescriptionImages);
            setTimeout(() => {
                scrollToAnchor(item)
            }, 500);
        } else {
            scrollToAnchor(item)
        }
        e.stopPropagation()
    })
})

// ленивая загрузка видео
const videoPlaceholder = document.querySelector('.video-placeholder');

if (videoPlaceholder instanceof HTMLElement) {
// Функция для замены заглушки на видео
    function loadVideo() {
        const videoIframe = document.createElement('iframe');
        videoIframe.width = '560';
        videoIframe.height = '315';
        videoIframe.src = videoPlaceholder.dataset.src;
        videoIframe.title = 'YouTube video player';
        videoIframe.frameBorder = '0';
        videoIframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        videoIframe.allowFullscreen = true;
        videoPlaceholder.parentNode.replaceChild(videoIframe, videoPlaceholder);
    }

// Проверяем, когда заглушка видна в области просмотра
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                loadVideo();
                observer.unobserve(videoPlaceholder);
            }
        });
    });

    observer.observe(videoPlaceholder);
}



// отзывы
let wrapper = document.querySelector('#product-reviews-root')
if (wrapper) new Reviews().init(wrapper)

// Блок доставки твоара
let productDeliveryNode = document.getElementById('product-delivery-root')
if (productDeliveryNode instanceof HTMLElement) {
    let params = {
        id: productDeliveryNode.dataset.productId,
        merchant: productDeliveryNode.dataset.productMerchant,
        price: Number(productDeliveryNode.dataset.productPrice)
    }
    const productDeliveryRoot = createRoot(productDeliveryNode)
    productDeliveryRoot.render(<Suspense fallback={<></>}><ProductDelivery {...params}/></Suspense>)
}

// Блок для информации о версиях global/ua/esim
let productNewAlternativeInfoNode = document.querySelector('.new-alternative-info-root')
if (productNewAlternativeInfoNode instanceof HTMLElement) {
    let params = {lang: lang}
    const productNewAlternativeInfoRoot = createRoot(productNewAlternativeInfoNode)
    productNewAlternativeInfoRoot.render(<Suspense fallback={<></>}><ProductNewAlternativeInfo {...params} /></Suspense>)
}
// Блок для информации о версиях б/у
let productAlternativeInfoNode = document.querySelector('.alternative-info-root')
if (productAlternativeInfoNode instanceof HTMLElement) {
    let params = {lang: lang}
    const productAlternativeInfoRoot = createRoot(productAlternativeInfoNode)
    productAlternativeInfoRoot.render(<Suspense fallback={<></>}><ProductAlternativeInfo {...params} /></Suspense>)
}


// Рекомендуемые товары
let reccomsProductNode = document.getElementById('reccoms-products')
if (reccomsProductNode instanceof HTMLElement) {
    let reccomsProductsParams = {
        componentParams: {
            template: reccomsProductNode.dataset.template,
            params: reccomsProductNode.dataset.params,
            component: reccomsProductNode.dataset.component,
            filter: reccomsProductNode.dataset.filter,
            lang: lang,
            sessid: sessid
        }
    };
    reccomsProductNode.dataset.template = ''
    reccomsProductNode.dataset.params = ''
    reccomsProductNode.dataset.component = ''
    reccomsProductNode.dataset.filter = ''

    const reccomsRoot = createRoot(reccomsProductNode)
    reccomsRoot.render(
        <Suspense fallback={<></>}>
            <CrossProductList {...reccomsProductsParams} rootNode={reccomsProductNode} title={'CATALOG_RECOMMENDATION_TITLE'}/>
        </Suspense>
    )
}

// Блок просмотренные товары
let viewedProductNode = document.querySelector('.viewed-products')
if (viewedProductNode instanceof HTMLElement &&
    typeof productViewed !== 'undefined' &&
    productViewed &&
    Object.keys(productViewed).length > 0) {
    const viewedProductRoot = createRoot(viewedProductNode)
    viewedProductRoot.render(<Suspense fallback={<></>}><Viewed {...productViewed} variant="product"/></Suspense>)
}

// Список гарантий к товару
let productWarantyNode = document.getElementById('product-warranty-list-root')
if (productWarantyNode instanceof HTMLElement) {
    try {
        let props = JSON.parse(atob(window.productWarranty))
        const productWarrantyRoot = createRoot(productWarantyNode)
        productWarrantyRoot.render(<ProductGuaranteeList {...props}/>)
    } catch (exception) {
        console.log(exception)
    }
}

// Блок акции на товаре
let productSpecialDealNode = document.getElementById('product-special-deal-root')
if (productSpecialDealNode instanceof HTMLElement) {
    try {
        let props = JSON.parse(atob(window.productSpecialDeal))
        const productSpecialDealRoot = createRoot(productSpecialDealNode)
        productSpecialDealRoot.render(<ProductSpecialDeal {...props}/>)
    } catch (exception) {
        console.log(exception)
    }
}

// Блок контента для Б/У техники
let usedProductContentNode = document.getElementById('used-product-content-root')
if (usedProductContentNode instanceof HTMLElement) {
    let usedProductContentParams = {
        params: usedProductContentNode.dataset.params
    };

    usedProductContentNode.dataset.params = ''

    const usedProductContentRoot = createRoot(usedProductContentNode)
    usedProductContentRoot.render(
      <Suspense fallback={<></>}>
          <UsedProductContentSection {...usedProductContentParams}/>
      </Suspense>
    )
}

// Блок "Другие разделы"
let productRelatedLinksNode = document.getElementById('product-related-links-root')
if (productRelatedLinksNode instanceof HTMLElement) {
    let productRelatedLinksParams = {
        componentParams: {
            template: productRelatedLinksNode.dataset.template,
            params: productRelatedLinksNode.dataset.params,
            component: productRelatedLinksNode.dataset.component,
            lang: lang,
            sessid: sessid
        }
    };
    productRelatedLinksNode.dataset.template = ''
    productRelatedLinksNode.dataset.params = ''
    productRelatedLinksNode.dataset.component = ''

    const productRelatedLinksRoot = createRoot(productRelatedLinksNode)
    productRelatedLinksRoot.render(
      <Suspense fallback={<></>}>
          <ProductRelatedLinks {...productRelatedLinksParams}/>
      </Suspense>
    )
}

// Скоро в продаже
let soonSaleNode = document.getElementById('soon-sale-products-root')
if (soonSaleNode instanceof HTMLElement) {
    let soonSaleParams = {
        componentParams: {
            template: soonSaleNode.dataset.template,
            params: soonSaleNode.dataset.params,
            component: soonSaleNode.dataset.component,
            filter: soonSaleNode.dataset.filter,
            lang: lang,
            sessid: sessid
        }
    };
    soonSaleNode.dataset.template = ''
    soonSaleNode.dataset.params = ''
    soonSaleNode.dataset.component = ''
    soonSaleNode.dataset.filter = ''

    const soonSaleRoot = createRoot(soonSaleNode)
    soonSaleRoot.render(
      <Suspense fallback={<></>}>
          <CrossProductList {...soonSaleParams} rootNode={soonSaleNode} title={'CATALOG_EXPECTED_TITLE'}/>
      </Suspense>
    )
}

// Новинки
let latestProductsNode = document.getElementById('latest-products-root')
if (latestProductsNode instanceof HTMLElement) {
    let latestProductsParams = {
        componentParams: {
            template: latestProductsNode.dataset.template,
            params: latestProductsNode.dataset.params,
            component: latestProductsNode.dataset.component,
            filter: latestProductsNode.dataset.filter,
            lang: lang,
            sessid: sessid
        }
    };
    latestProductsNode.dataset.template = ''
    latestProductsNode.dataset.params = ''
    latestProductsNode.dataset.component = ''
    latestProductsNode.dataset.filter = ''

    const latestRoot = createRoot(latestProductsNode)
    latestRoot.render(
      <Suspense fallback={<></>}>
          <CrossProductList {...latestProductsParams} rootNode={latestProductsNode} title={'CATALOG_LATEST_TITLE'}/>
      </Suspense>
    )
}

// смена данных при наведении
let relinkItemsList = document.querySelectorAll('.product-parameter-value .value-item')
let itemNameTitle = document.querySelector('.product-title-name.desktop-view h1')
let itemPrice = document.querySelector('.price-uah')
let itemBasePrice = document.querySelector('.product-base-price') // цена без корпоративной скидки
let itemOldPrice = document.querySelector('.product-main-price .price-old span')
let itemDiscountPercent = document.querySelector('.discount-percent')
let itemFioletovoDiscount = document.querySelector('.benefit-holder div span')
let itemDiscount = document.querySelector('.discount-price')
let itemCashbackList = document.querySelectorAll('.cashback-holder b') // кешбек может выводиться в нескольких местах (моб/десктоп)
let itemBarCode = document.querySelector('.product-code.desktop-view span')
let itemBarCodeHolder = document.querySelector('.product-code.desktop-view')
let itemArticle = document.querySelector('.product-vendor-code.desktop-view span')
let itemReviewsHolder = document.querySelector('.reviews-item-link')
let itemReviewsCount = document.querySelector('.reviews-link span')

if(relinkItemsList.length > 0) {
    let mainPhoto = document.querySelector('.product-item-detail-image img')
    const mainPhotoSrc = mainPhoto.src;
    const defaultName = itemNameTitle ? itemNameTitle.textContent : null;
    const defaultPrice = itemPrice ? itemPrice.textContent : null;
    const defaultBasePrice = itemBasePrice ? itemBasePrice.textContent : null;
    const defaultArticle = itemArticle ? itemArticle.textContent : null;
    const defaultOldPrice = itemOldPrice ? itemOldPrice.textContent : null;
    const defaultDiscountPercent = itemDiscountPercent ? itemDiscountPercent.textContent : null;
    const defaultFioletovoDiscount = itemFioletovoDiscount ? itemFioletovoDiscount.textContent : null;
    const defaultDiscount = itemDiscount ? itemDiscount.textContent : null;
    const defaultCashback = itemCashbackList.length ? itemCashbackList[0].textContent : null;
    const defaultDBarCode = itemBarCode ? itemBarCode.textContent : null;
    const defaultReviewsCount = itemReviewsCount ? itemReviewsCount.textContent : null;

    if (itemArticle instanceof HTMLElement) {
        const itemWidth = itemArticle.clientWidth;
        itemArticle.style.minWidth = `${itemWidth}px`;
        itemArticle.style.maxWidth = `${itemWidth + 10}px`;
    }

    if (itemReviewsHolder instanceof HTMLElement) {
        const reviewWidth = itemReviewsHolder.clientWidth;
        itemReviewsHolder.style.minWidth = `${reviewWidth}px`;
        itemReviewsHolder.style.maxWidth = `${reviewWidth + 10}px`;
    }

    if (itemBarCodeHolder instanceof HTMLElement) {
        const barCodeWidth = itemBarCodeHolder.clientWidth;
        itemBarCodeHolder.style.minWidth = `${barCodeWidth}px`;
        itemBarCodeHolder.style.maxWidth = `${barCodeWidth + 10}px`;
    }
    relinkItemsList.forEach(relink => {
        relink.addEventListener('mouseover', event => {
            const encodedData = relink.dataset.properties;
            const properties = JSON.parse(atob(encodedData));

            if (properties.image) mainPhoto.src = properties.image;
            if (properties.name && itemNameTitle) {
                const lineHeight = parseInt(window.getComputedStyle(itemNameTitle).lineHeight, 10);
                const height = itemNameTitle.offsetHeight;
                const lines = Math.round(height / lineHeight);
                itemNameTitle.style.maxHeight = `${itemNameTitle.clientHeight}px`
                itemNameTitle.style.minHeight = `${itemNameTitle.clientHeight}px`
                itemNameTitle.style.WebkitLineClamp = lines;
                itemNameTitle.classList.add('overflow')
                itemNameTitle.textContent = properties.name;
            }
            if (properties.price && itemPrice && (properties.price).replace(/\s|₴/g, '') > 0) itemPrice.textContent = properties.price;
            if (properties.basePrice && itemBasePrice && (properties.basePrice).replace(/\s|₴/g, '') > 0) itemBasePrice.textContent = properties.basePrice;
            if (properties.article && itemArticle) {
                itemArticle.textContent = properties.article;
                itemArticle.classList.add('overflow')
            }
            if (properties.old_price && itemOldPrice && properties.old_price > 0) itemOldPrice.textContent = properties.old_price_formated;
            if (itemDiscountPercent) {
                // при фиолетовой скидке плашка показывает разницу без неё
                const diffPrice = itemBasePrice ? properties.baseDiffPrice : properties.diffPrice;
                const diffPriceFormated = itemBasePrice ? properties.baseDiffPriceFormated : properties.diffPriceFormated;
                if (diffPrice && diffPrice > 0) itemDiscountPercent.textContent = '- ' + diffPriceFormated;
            }
            if (properties.discount && itemFioletovoDiscount) itemFioletovoDiscount.textContent = properties.discount;
            if (properties.discount && itemDiscount) itemDiscount.textContent = properties.discount;
            if (properties.cashback) itemCashbackList.forEach(item => item.textContent = properties.cashback);
            if (properties.bar_code && itemBarCode) itemBarCode.textContent = properties.bar_code;
            if (properties.reviews_count && itemReviewsCount) itemReviewsCount.textContent = properties.reviews_count;
        });

        relink.addEventListener('mouseleave', event => {
            mainPhoto.src = mainPhotoSrc;
            if (itemNameTitle) {
                itemNameTitle.textContent = defaultName;
                itemNameTitle.style = '';
                itemNameTitle.classList.remove('overflow')
            }
            if (itemPrice) itemPrice.textContent = currentProductPrice || defaultPrice;
            if (itemBasePrice) itemBasePrice.textContent = defaultBasePrice;
            if (itemArticle) {
                itemArticle.textContent = defaultArticle;
                itemArticle.classList.remove('overflow')
            }
            if (itemOldPrice) itemOldPrice.textContent = defaultOldPrice;
            if (itemDiscountPercent) itemDiscountPercent.textContent = defaultDiscountPercent;
            if (itemFioletovoDiscount) itemFioletovoDiscount.textContent = defaultFioletovoDiscount;
            if (itemDiscount) itemDiscount.textContent = defaultDiscount;
            itemCashbackList.forEach(item => item.textContent = defaultCashback);
            if (itemBarCode) itemBarCode.textContent = defaultDBarCode;
            if (itemReviewsCount) itemReviewsCount.textContent = defaultReviewsCount;
        });
    });
}

// Топ продаж
let topProductsNode = document.getElementById('top-products-root')
// for products without additional items
let topProductsUpperNode = document.getElementById('top-products-upper-root')
if (topProductsNode instanceof HTMLElement) {
    let topProductsParams = {
        componentParams: {
            template: topProductsNode.dataset.template,
            params: topProductsNode.dataset.params,
            component: topProductsNode.dataset.component,
            filter: topProductsNode.dataset.filter,
            lang: lang,
            sessid: sessid
        }
    };
    topProductsNode.dataset.template = ''
    topProductsNode.dataset.params = ''
    topProductsNode.dataset.component = ''
    topProductsNode.dataset.filter = ''

    topProductsUpperNode instanceof HTMLElement ? topProductsNode.style.minHeight = '0' : '';

    const topRoot = createRoot(topProductsUpperNode ? topProductsUpperNode : topProductsNode)
    topRoot.render(
      <Suspense fallback={<></>}>
          <CrossProductList {...topProductsParams} rootNode={topProductsUpperNode ? topProductsUpperNode : topProductsNode} secondRootNode={topProductsNode} title={'CATALOG_TOP_TITLE'}/>
      </Suspense>
    )
}

// special deal timer
let specialDealTimerContainer = document.getElementById('special-deal-data-active');
if (specialDealTimerContainer instanceof HTMLElement) {
    let specialDealTimerContainerParams = {
        componentParams: {
            active: specialDealTimerContainer.dataset.active,
            lang: lang,
            sessid: sessid
        }
    };

    const timerRoot = createRoot(specialDealTimerContainer);
    timerRoot.render(
      <Suspense fallback={<></>}><TimeRemaining {...specialDealTimerContainerParams}/></Suspense>
    )
}



// copy indication promocode
let shareLinkNode = document.querySelector('.promocode__row');
if (shareLinkNode instanceof HTMLElement) {
    import(/* webpackPreload: true */ 'clipboard-copy')
      .then(({default: clipboardCopy}) => {
          let shareBlock = shareLinkNode.querySelector('.copy-link');
          let shareLink = shareLinkNode.querySelector('.promocode-text');
          let shareLinkSaved = shareLinkNode.querySelector('.article-saved');
          shareBlock.addEventListener('click', e => {
              clipboardCopy(shareLink.textContent);
              shareBlock.classList.remove('active');
              shareLinkSaved.classList.add('active');
              setTimeout(() => {
                  shareBlock.classList.add("active");
                  shareLinkSaved.classList.remove('active');
              }, 3000);
          });
      });
}

// fixed about product titles for desktop
const productDescrBlock = document.querySelector('.product-card-section')

if(productDescrBlock && window.innerWidth > 767) {
    let blockRect = productDescrBlock.getBoundingClientRect();
    let breadcrumbs = document.querySelector('.product-card-section .breadcrumbs')

    const descrHandleScroll = () => {
        blockRect = productDescrBlock.getBoundingClientRect();
        if(blockRect.top + breadcrumbs.clientHeight < 0) {
            productDescrBlock.classList.add('fixed-menu')
        }  else {
            productDescrBlock.classList.remove('fixed-menu')
        }
    }
    document.addEventListener('scroll', descrHandleScroll)
}

// for mob version header
if (window.document.documentElement.clientWidth <= 767) {
    let headerBlock = document.querySelector('#header')
    let aboutBlock = document.querySelector('.about-product-titles.mob')
    let mainBlock = document.querySelector('body.product-page .main')

    // hide breadcrumbs on mob
    let breadcrumbsContainer = document.querySelector('.breadcrumbs-list');
    let breadcrumbsList = breadcrumbsContainer.querySelectorAll('li');
    if (breadcrumbsList.length >= 2) {
        // Находим предпоследний элемент <li>
        let targetIndex = breadcrumbsList.length - 2;
        breadcrumbsList[targetIndex].classList.add('breadcrumbs-item')
    }

    function makePosition () {
        let offsetY = window.pageYOffset
        let pageHasMobBanner = document.getElementById('top-banner');
        let needOffset = 95
        let setPaddingTop = '33px'

        if (pageHasMobBanner) {
            needOffset = 127
            setPaddingTop = '33px'
        }

        if (offsetY > needOffset) {
            aboutBlock.classList.add('fixed')
            mainBlock.style.paddingTop = setPaddingTop
        } else {
            aboutBlock.classList.remove('fixed')
            mainBlock.style.paddingTop = 'unset'
        }
    }

    makePosition()
    document.addEventListener('scroll', event => {makePosition()})
}
// for mob version header end

const animateSectionContent = (content, opening) => {
    if (content.sectionAnimation) {
        content.sectionAnimation.cancel();
    }

    if (opening) {
        content.style.display = 'block';
    }

    const styles = window.getComputedStyle(content);
    const fullHeight = content.getBoundingClientRect().height;
    const verticalStyles = {
        paddingTop: styles.paddingTop,
        paddingBottom: styles.paddingBottom,
        marginTop: styles.marginTop,
        marginBottom: styles.marginBottom
    };
    const collapsedStyles = {
        height: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        marginTop: '0px',
        marginBottom: '0px'
    };
    const expandedStyles = {
        height: `${fullHeight}px`,
        ...verticalStyles
    };

    content.style.overflow = 'hidden';
    content.style.boxSizing = 'border-box';
    content.style.minHeight = '0';

    const animation = content.animate(
        opening
            ? [collapsedStyles, expandedStyles]
            : [expandedStyles, collapsedStyles],
        {
            duration: 400,
            easing: 'ease'
        }
    );

    content.sectionAnimation = animation;
    animation.onfinish = () => {
        if (content.sectionAnimation !== animation) return;

        content.style.display = opening ? 'block' : 'none';
        content.style.height = '';
        content.style.overflow = '';
        content.style.boxSizing = '';
        content.style.minHeight = '';
        content.sectionAnimation = null;
    };
};

document.addEventListener('click', event => {
    const title = event.target.closest('.section-item-title');
    if (!title) return;
    const parent = title.parentElement;
    const content = title.nextElementSibling;
    if (!parent || !content) return;
    const shouldOpen = !parent.classList.contains('active') || getComputedStyle(content).display === 'none';
    parent.classList.toggle('active', shouldOpen);
    animateSectionContent(content, shouldOpen);
});

// Share links
let shareDepencyLoaded = false;
[].slice.apply(document.querySelectorAll('.share_link_js'))
    .forEach((item, index) => {
        let dropDownContainer = item.closest('.dropdown-main-container');
        item.addEventListener('click', (e) => {
            e.preventDefault();
            if (!shareDepencyLoaded) {
                import(/* webpackChunkName: 'goodshare' */ 'goodshare.js').then(module => {
                    shareDepencyLoaded = true;
                    if (!dropDownContainer.classList.contains('opened')) dropDownContainer.classList.add('opened');
                    else dropDownContainer.classList.remove('opened');
                });
            } else {
                if (!dropDownContainer.classList.contains('opened')) dropDownContainer.classList.add('opened');
                else dropDownContainer.classList.remove('opened');
            }
        });
    });

// Product logic
let holder = document.querySelector('.product-card-box');
if (holder instanceof HTMLElement) {
    let productData = holder.dataset.product;
    let product = new Product(holder);
    product.data = product.decodeData(productData);

    // mulisearch tracking
    try {
        let ms_product_id = product.data['PROPERTIES']['CML2_BAR_CODE']['VALUE']
        eventEmitter.emit('MSClick', { productId: ms_product_id })
    } catch (reason) {
        console.log(reason)
    }

    // send ga4 view item event
    analytics.viewItem(Number(product.data.ID), product.data.ga4);

    let stickyData = product.data
    // Плавающий товар
    let productStickyNode = document.getElementById('sticky-product-scroll-root')
    let showCredit = productStickyNode ? productStickyNode.getAttribute('data-credit') : '';
    if (productStickyNode instanceof HTMLElement) {
        const stickyRoot = createRoot(productStickyNode)
        stickyRoot.render(<Suspense fallback={<></>}><ProductSticky {...stickyData} showCredit={showCredit} productRef={product}/></Suspense>)
    }

    //Espuntik Tracker
    eventEmitter.on('EsputnikLoaded', () => {
        esputnikTracker.ProductPage(product.data['data_esputnik']);
    });

    //Remarketing
    if (product.data.hasOwnProperty('data_layer'))
        dynRem.pushToDataLayer(product.data['data_layer']);

    // Событие просмотра товара facebook
    if (product.data.hasOwnProperty('fbq_view_content'))
        eventEmitter.on('facebookLoaded', () => {
            dynRem.pushFbqEvent('ViewContent', product.data['fbq_view_content']);
        })

    // Facebook событие просмотра товара через post
    if (product.data.hasOwnProperty('eventFBParams')) {
      analytics.facebookViewContentPost(product.data['eventFBParams']);
    }

    if (product.data.hasOwnProperty('fbq_view'))
        dynRem.pushFbqEvent('ViewContent', product.data['fbq_view']);

    product.initEvents();
    // Wish list
    //main block button
    eventEmitter.emit('handleWishlistItems', {
        node: document.querySelector('.product-view [data-container="favorite"][data-use="add"]'),
        range: 'product1'
    });

    eventEmitter.emit('handleCompareItems', {
        node: document.querySelectorAll('.product-card-box [data-container="compare"], .product-item-descr [data-container="compare"]'),
        range: 'product'
    });

    // Слайдер основной
    const swiper = new Swiper('.product-pictures-swiper', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 0,
        setWrapperSize: true,
        loop: true,
        on: {
            slideChange: function (swiper) {
                let index = swiper.realIndex;
                // Деактивация предыдущего
                let activePreviewPicture = product.previewPicturesBox.querySelector('.img-control-preview.active-preview');
                if (activePreviewPicture instanceof HTMLElement) {
                    activePreviewPicture.classList.remove('active-preview');
                }
                let newPreviewPicture = product.previewPicturesBox.querySelector(`.img-control-preview[data-index="${index}"]`);
                if (newPreviewPicture instanceof HTMLElement) {
                    newPreviewPicture.classList.add('active-preview');
                }
            },
        },
        navigation: {
            nextEl: ".detail-slider.swiper-button-next",
            prevEl: ".detail-slider.swiper-button-prev",
        },
        breakpoints: {
            0: {
                pagination: {
                    el: ".product-item-detail-slider-container .swiper-pagination",
                    type: 'fraction',
                    renderFraction: function (currentClass, totalClass) {
                        return `<span class="${currentClass}"></span> / <span class="${totalClass}"></span>`;
                    }
                }
            },
            768: {
                pagination: false
            }
        }
    });

    // Клик по превью
    [].slice.apply(document.querySelectorAll('.product-preview-holder .img-control-preview')).forEach(preview => {
        preview.addEventListener('click', e => {
            let preview = e.currentTarget;
            let index = parseInt(preview.dataset.index, 10); // Преобразуем индекс в целое число
            if (index >= 0) {
                swiper.slideToLoop(index); // Переход к слайду с учетом loop
            }
            // Деактивация предыдущего
            let activePreviewPicture = product.previewPicturesBox.querySelector('.img-control-preview.active-preview');
            if (activePreviewPicture instanceof HTMLElement) {
                activePreviewPicture.classList.remove('active-preview');
            }
            preview.classList.add('active-preview');
        });
    });


    window.addEventListener('resize', () => {
        product.initStickly();
    });

    // Detail product popup
    let productModalNode = document.querySelector('#product-modal-root')
    if (productModalNode instanceof HTMLElement) {
        let productModalData = product.data

        const productModalRoot = createRoot(productModalNode)
        productModalRoot.render(<Suspense fallback={<></>}><ProductModal {...productModalData} openTriggerItems={product.detailPopupTriggerElements}/></Suspense>)
    }

    // Блок "Дешевле чем новый"
    let cheaperThanNewNode = document.getElementById('cheaper-than-new');
    if (cheaperThanNewNode instanceof HTMLElement) {
        try {
            let activeStateParameter = document.querySelector('.product-parameter-value .value-item.bu-alternative.active');
            if (activeStateParameter?.dataset.properties) {
                let activeStateProperties = JSON.parse(atob(activeStateParameter.dataset.properties));
                if (activeStateProperties.cheaperPrice > 0) {
                    const cheaperRoot = createRoot(cheaperThanNewNode);
                    cheaperRoot.render(
                      <Suspense fallback={<></>}>
                          <CheaperThanNew {...activeStateProperties} rootNode={cheaperThanNewNode} />
                      </Suspense>
                    );
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    // credit services
    let creditServicesNode = document.getElementById('credit-services-root');
    if (creditServicesNode instanceof HTMLElement) {
        try {
            let props = JSON.parse(atob(creditServicesNode.dataset.params))
            const creditServicesRoot = createRoot(creditServicesNode)
            creditServicesRoot.render(<CreditServicesList {...props}/>)
        } catch (exception) {
            console.log(exception)
        }
    }

    // комплекты
    let productSetBlock = document.querySelector('#product-set-block')
    if (productSetBlock instanceof HTMLElement) {
        const productSetRoot = createRoot(productSetBlock)
        productSetRoot.render(<SetList {...productSet} />)
    }

    // кнопка активации trade in
    let tradeInNode = document.getElementById('trade-in-root')
    let tradeInBtn = document.getElementById('trade-in-btn')

    if (tradeInNode instanceof HTMLElement && tradeInBtn instanceof HTMLElement) {
        tradeInBtn.addEventListener('click', () => {
            eventEmitter.emit('showTradeIn')
        })

        let props = {
            lang: lang,
            sessid: sessid,
            componentParams: {
                template: tradeInNode.dataset.template,
                params: tradeInNode.dataset.params,
                component: tradeInNode.dataset.component,
            },
            productId: Number(product.data.ID)
        }

        const tradeInRoot = createRoot(tradeInNode)
        tradeInRoot.render(<Suspense fallback={<></>}><TradeIn {...props}/></Suspense>)
    }
}

/**
 * Показ инфо окна на мобильных устройствах
 * Важно
 * - родительский элемент должен быть с классом js_info
 * - элемент с текстом заголовка с классом js_title
 * - элемент с текстом описания с классом js_body
 */

let info_items = document.querySelectorAll('.js_info')
info_items.forEach(info_item => {
    info_item.addEventListener('click', event => {
        console.dir(event)
        event.preventDefault()
        let info_obj = event.target

        let title = info_obj.querySelector('.js_title')
        let body = info_obj.querySelector('.js_body')

        if (title && body) {
            import(/* webpackPreload: true */ './popup/index')
              .then(module => {
                  let popup = new module.Popup('info', false)
                  // Устанавливаем тело окна
                  popup.body =
                    `<div class="info-popup-title">${title.textContent}</div>` +
                    `<div class="info-popup-body">${body.textContent}</div>`
                  popup.open()
              })
        }
    })
})

//Apple pay
try {
    if (ApplePayHelper.checkSession()) {
        let applePayButton = document.querySelector('#apple-pay-btn');
        if ((applePayButton instanceof HTMLElement)
          && applePayButton.dataset.hasOwnProperty('params')) {
            let applePayOrderParams = JSON.parse(atob(applePayButton.dataset.params));
            let applePayShippingList = JSON.parse(atob(applePayButton.dataset.shipping));
            let orderAjaxUrl = atob(applePayButton.dataset.url);
            applePayButton.addEventListener('click', () => {
                let price = Number(applePayOrderParams['price']);
                if (applePayOrderParams['percent'] > 0) {
                    price = applePayOrderParams['price'] + Math.ceil(applePayOrderParams['price'] * (applePayOrderParams['percent'] / 100));
                }
                let paymentRequest = ApplePayHelper.makePaymentRequest(price);
                if (Array.isArray(applePayShippingList) && applePayShippingList.length > 0)
                    paymentRequest.shippingMethods = applePayShippingList;
                paymentRequest.lineItems = [
                    {
                        label: applePayOrderParams['name'],
                        amount: price,
                        type: 'final'
                    }
                ];
                const session = new ApplePaySession(1, paymentRequest);
                session.begin();
                let selectedDeliveryId = 0;
                session.onshippingmethodselected = event => {
                    selectedDeliveryId = Number(event.shippingMethod.identifier);
                    let data = {
                        label: event.shippingMethod.label,
                        amount: price + Number(event.shippingMethod.amount),
                        type: 'final',
                    };
                    session.completeShippingMethodSelection({
                        status: ApplePaySession.STATUS_SUCCESS,
                        newTotal: data
                    });
                };
                let paymentCanceled = false;
                session.oncancel = event => {
                    paymentCanceled = true;
                    eventEmitter.emit('hideLoader');
                };
                session.onvalidatemerchant = event => {
                    if (paymentCanceled) {
                        return;
                    }
                    ApplePayHelper.validateMerchant(event.validationURL)
                      .then(response => {
                          return response.json();
                      })
                      .then(merchantSession => {
                          session.completeMerchantValidation(merchantSession);
                      });
                }
                session.onpaymentauthorized = event => {
                    let orderFields = ApplePayHelper.makePaymentFields(event.payment, {PRICE: price});
                    let token = event.payment.token;
                    let paymentData = {
                        token: btoa(JSON.stringify(token)),
                        fields: orderFields
                    };
                    if (paymentCanceled) {
                        return;
                    }
                    let orderFormData = {
                        "ORDER_PROP_6": "",
                        "ORDER_PROP_7": "",
                        "ORDER_PROP_34": "",
                        "ORDER_PROP_42": "",
                        "ORDER_PROP_43": "",
                        "ORDER_PROP_44": "",
                        "ORDER_PROP_45": ""
                    };
                    if (orderFields.hasOwnProperty('FIO'))
                        orderFormData['ORDER_PROP_1'] = orderFields['FIO'];
                    if (orderFields.hasOwnProperty('NAME'))
                        orderFormData['ORDER_PROP_48'] = orderFields['NAME'];
                    if (orderFields.hasOwnProperty('LAST_NAME'))
                        orderFormData['ORDER_PROP_49'] = orderFields['LAST_NAME'];
                    if (orderFields.hasOwnProperty('PHONE'))
                        orderFormData['ORDER_PROP_3'] = orderFields['PHONE'];
                    if (orderFields.hasOwnProperty('EMAIL'))
                        orderFormData['ORDER_PROP_2'] = orderFields['EMAIL'];
                    if (orderFields.hasOwnProperty('ADDRESS'))
                        orderFormData['ORDER_PROP_7'] = orderFields['ADDRESS'];
                    if (selectedDeliveryId > 0)
                        orderFormData['DELIVERY_ID'] = selectedDeliveryId;
                    orderFormData['apple_pay'] = 'Y';
                    orderFormData['PAY_SYSTEM_ID'] = applePayOrderParams['paySystemId'];
                    orderFormData['sessid'] = sessid;
                    orderFormData['lang'] = lang;
                    orderFormData['via_ajax'] = 'Y';
                    orderFormData['SITE_ID'] = applePayOrderParams['siteId'];
                    //Add order
                    ApplePayHelper.addOrder(orderFormData, applePayOrderParams['productId'], orderAjaxUrl)
                      .then(response => {
                          return response.json();
                      }).then(orderResult => {
                        if (orderResult.hasOwnProperty('order')
                          && orderResult.order.REDIRECT_URL
                          && orderResult.order.REDIRECT_URL.length) {
                            paymentData['order_id'] = orderResult.order.ID;
                            paymentData['redirect_url'] = orderResult.order.REDIRECT_URL;
                            ApplePayHelper.paymentAuthorized(JSON.stringify(paymentData))
                              .then(response => {
                                  return response.json();
                              })
                              .then(
                                result => {
                                    if (result.hasOwnProperty('success') && result.success) {
                                        session.completePayment(ApplePaySession.STATUS_SUCCESS);
                                        if (result.hasOwnProperty('redirect') && result.redirect.length) {
                                            let redirectData = JSON.parse(atob(result.redirect));
                                            let form = document.createElement('form');
                                            form.setAttribute('method', redirectData['method']);
                                            form.setAttribute('action', redirectData['url']);
                                            form.style.display = 'none';
                                            if (redirectData.hasOwnProperty('params')) {
                                                for (let i in redirectData.params) {
                                                    if (!redirectData.params.hasOwnProperty(i)) continue;
                                                    // TEH-1606 (F31): параметры ответа шлюза — только через свойства DOM-узла,
                                                    // интерполяция в HTML открывала инъекцию из ответа шлюза
                                                    const hiddenInput = document.createElement('input')
                                                    hiddenInput.type = 'hidden'
                                                    hiddenInput.name = i
                                                    hiddenInput.value = redirectData.params[i]
                                                    form.appendChild(hiddenInput);
                                                }
                                            }
                                            document.body.append(form);
                                            form.submit();
                                        } else {
                                            document.location.href = orderResult.order.REDIRECT_URL;
                                        }
                                        eventEmitter.emit('hideLoader');
                                    } else {
                                        session.completePayment(ApplePaySession.STATUS_FAILURE);
                                        document.location.href = orderResult.order.REDIRECT_URL;
                                        eventEmitter.emit('hideLoader');
                                    }
                                },
                                error => {
                                    console.dir(error);
                                    document.location.href = orderResult.order.REDIRECT_URL;
                                    eventEmitter.emit('hideLoader');
                                }
                              );
                        } else {
                            session.completePayment(ApplePaySession.STATUS_FAILURE);
                            eventEmitter.emit('hideLoader');
                        }
                    });
                }
            });
        }
    }
} catch (e) {
    console.error(e);
    eventEmitter.emit('hideLoader');
}